/**
 * @fileoverview Content Skeleton component main React interface.
 * This component is influenced by and modifies https://github.com/dvtng/react-loading-skeleton.
 */
// @ts-nocheck
goog.declareModuleId('yext.ui.components.contentskeleton');

/**
 * @param {{
 *   height?: (string|number),
 *   numRows?: number,
 *   tid?: string,
 *   type?: string,
 *   width?: (string|number),
 * }} props
 * @return {React.ReactElement}
 */
export function ContentSkeleton({
  height,
  numRows = 1,
  tid,
  type = 'row',
  width = '100%',
}) {
  const containerStyle = {
    width,
  };

  // Only set height if a value is provided and type === 'box'.
  // Otherwise, pull row height value from CSS.
  if (height && type === 'box') {
    containerStyle.height = height;
  }

  const elements = [];

  // If type === 'box', disregard numRows and only push a single element.
  if (type === 'box') {
    elements.push(
      <span key={0} className="ui-content-skeleton__element ui-content-skeleton__element--box">
        &zwnj;
      </span>,
    );
  } else if (type === 'row') {
    // If type === 'row', loop through numRows to push elements equal to numRows.
    for (let i = 0; i < numRows; i++) {
      elements.push(
        <span key={i} className="ui-content-skeleton__element ui-content-skeleton__element--row">
          &zwnj;
        </span>,
      );
    }
  } else if (type === 'pill') {
    elements.push(
      <span key={0} className="ui-content-skeleton__element ui-content-skeleton__element--pill">
        &zwnj;
      </span>,
    );
  } else if (type === 'circle') {
    const circleStyle = {
      height: 0,
      paddingBottom: '100%',
      borderRadius: '50%',
    };

    elements.push(
      <span key={0} className="ui-content-skeleton__element" style={circleStyle}>
        &zwnj;
      </span>,
    );
  }

  return (
    <div className="ui-content-skeleton__container" style={containerStyle} aria-hidden={true} tid={tid}>
      {elements}
    </div>
  );
}
